import { render, staticRenderFns } from "./LocationProfileHistory.vue?vue&type=template&id=5572ee94&scoped=true&"
import script from "./LocationProfileHistory.vue?vue&type=script&lang=js&"
export * from "./LocationProfileHistory.vue?vue&type=script&lang=js&"
import style0 from "./LocationProfileHistory.vue?vue&type=style&index=0&id=5572ee94&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5572ee94",
  null
  
)

export default component.exports